import React, { Component } from 'react';
import { CommonlyHeadMembers } from '../../common/headnav';
import { WingBlank, WhiteSpace } from 'antd-mobile';
import './style.less';
export default class IntegralJqsm extends Component {
    render() {
        return <div className="integral">
            <CommonlyHeadMembers barname='检前说明' />
            <div className="sysm">
                <WingBlank size="lg">
                    <div className="sub-title">体检注意事项</div>
                    <WhiteSpace />
                    <div className="sysmdiv">
                        <span className="num">1</span>
                        <p>体检当日早晨应完全禁食禁水（ 如服用药物，可少量饮用白水）；体检前日请勿饮酒或油腻食物，避免剧烈运动，晚八点后不再进食饮水</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">2</span>
                        <p>糖尿病、高血压、心脏病等慢性病患者，请将平时服用药物携带备用</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">3</span>
                        <p>腹部B超检查(胆、肝、脾、胰、肾)时，必须空腹8-12小时，小儿空腹5小时</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">4</span>
                        <p>检查妇科(子宫、附件)、前列腺、膀胱时，须膀胱充盈(憋尿)</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">5</span>
                        <p>怀孕或可能已受孕的女性受检者，请事先告诉医护人员，勿做X光检查及子宫颈刮片检查； 无性生活史的女性，请切勿进行妇科检查、宫 颈涂片及TCT检查</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">6</span>
                        <p>经期女性不能做妇科检查（包括阴道彩超）及尿检，可于经期过后再补检</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">7</span>
                        <p>抽血时必须空腹8-12小时，儿童5小时；有晕血、晕针史，请告知抽血护士，以便做好预防措施。抽血后压迫针眼处3-5分钟</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">8</span>
                        <p>进行抽血、彩超检查后，方可进食</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">9</span>
                        <p>招工、应聘体检须于抽血前出示说明身份的证件</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">10</span>
                        <p>放射检查时：请先将您的病史及现有症状详细告知检查医师，勿佩戴耳环、项链等金银首饰；请勿将硬币、钢笔、打火机等小件物品放在 衬衣口袋，避免伪影</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">11</span>
                        <p>进行各科检查时，请务必按体检表内容进行逐项检查，若自动放弃检查某一项目造成漏诊，会影响对您健康状况的评估；如确因放弃某一 项目检查时，
                    您务必在未检项目上签字</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">12</span>
                        <p>全部项目检查完毕后，请您将体检表交回前台，如需补检，请择日领取补检单</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">13</span>
                        <p>您的健康体检报告需4-7个工作日即可在网上查询（检后到前台领取网上查询单指引单，通过个人的用户名及密码登录查询）</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">14</span>
                        <p>定期健康体检对促进人们的健康有重要作用，但受医学科技发展的限制及每人检查情况不同，本次体检并不能保证百分之百准确与全面， 所以体检结果仅供参考</p>
                    </div>
                    <WhiteSpace />
                </WingBlank>
            </div>
        </div>;
    }
}